export const langSpeedFrequencyChart = {
  fr: {
    speedFreqChartTitle: 'Vitesse GPS (knt) - Fréquence',
    speedFreqChartY: 'nb',
  },

  eng: {
    speedFreqChartTitle: 'GPS speed (knt) - Frequency',
    speedFreqChartY: 'nb',
  },
}
